// extracted by mini-css-extract-plugin
export default {"floatBox":"CNl7QD1FpnStvA1noMH8","fastEntry":"efxmWm2HE2zw8urAQIYc","common_bganimation":"eHrjZJIeaO9YCwC_e7CY"};